import * as React from 'react';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import TaxonomyThemeTeaser from './Teaser';
import TaxonomyThemePage from './Page';
import TaxonomyThemeTitle from './Title';
import { TaxonomyTheme } from '../../../types/uncinc_profile/taxonomy';

type TaxonomyViewmode = 'teaser' | 'page' | 'title';

interface TaxonomyThemeWrapperProps {
  entity: ImmutableEntity<TaxonomyTheme>;
  viewMode: TaxonomyViewmode;
}

const TaxonomyThemeWrapper: React.FC<TaxonomyThemeWrapperProps> =
  ({ entity, viewMode, ...props }) => {
    switch (viewMode) {
      case 'teaser':
        return <TaxonomyThemeTeaser entity={entity} {...props} />;
      case 'title':
        return <TaxonomyThemeTitle entity={entity} {...props} />;
      case 'page':
      default:
        return <TaxonomyThemePage entity={entity} {...props} />;
    }
  };

export default TaxonomyThemeWrapper;
